import { SPANNEND_TEXT, type SpannendSwitch } from './spannend.js';

/**
 * "Spannend: aan/uit" outside a class (ADR-043): in the desktop preview's
 * corner and on a played lesson's start card. Calm is the default; a change
 * applies from the next step, as the teacher's switch does. DOM, so it is
 * never seen inside a headset.
 */

export const SPANNEND_BUTTON_TITLE =
  'Bij Spannend komt een dier dichtbij en klinkt het harder. Geldt vanaf de volgende stap.';

export function spannendLabel(on: boolean): string {
  return on ? SPANNEND_TEXT.nl.on : SPANNEND_TEXT.nl.off;
}

export function spannendButton(
  spannend: SpannendSwitch,
  place: 'corner' | 'card',
  onChange: (on: boolean) => void = () => {},
): { element: HTMLButtonElement; remove: () => void } {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = place === 'card' ? 'lesson sound-toggle' : 'lesson sound-corner';
  button.title = SPANNEND_BUTTON_TITLE;
  const show = (): void => {
    button.textContent = spannendLabel(spannend.on);
    button.setAttribute('aria-pressed', String(spannend.on));
  };
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    spannend.set(!spannend.on);
    onChange(spannend.on);
    show();
  });
  show();
  return { element: button, remove: () => button.remove() };
}
